import React from 'react';
import { motion } from 'framer-motion';
import { fadeInUpInView } from '../lib/motionPresets';

const RENTAL_ITEMS = ['Chairs & Tables', 'Tents & Canopies', 'Linens', 'Decorations', 'Balloons', 'Backdrops', 'Cutlery', 'Dinnerware', 'Wine Glasses & Flutes', 'Water Glasses'];
const EVENT_TYPES = ['Weddings', 'Graduations', 'Birthday Parties', 'Baby Showers', 'Corporate Events'];

export const HomeAbout = () => (
  <section className="py-16 px-6 bg-white" data-testid="about-section">
    <div className="max-w-6xl mx-auto text-center">
      <motion.div {...fadeInUpInView}>
        <h2 className="text-4xl font-bold heading-font mb-6" style={{ color: '#7C3AED' }}>
          About Thomas Party & Decor
        </h2>
        <div className="bg-orange-50 rounded-3xl p-8 border-2 border-orange-200">
          <p className="text-lg text-gray-700 mb-4">
            <strong className="text-violet-700">Located in Aldan, PA 19018</strong>, we proudly service all of Havertown, Delaware County, Montgomery County, and surrounding Pennsylvania areas.
          </p>
          <p className="text-lg text-gray-700 mb-6">
            We specialize in providing high-quality party rental equipment for all your special occasions - from intimate gatherings to grand celebrations.
          </p>
          <div className="bg-white rounded-2xl p-6 border-2 border-orange-200 mb-6">
            <h3 className="text-xl font-bold heading-font text-orange-600 mb-4">Our Complete Rental Collection</h3>
            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3 text-gray-700">
              {RENTAL_ITEMS.map((item) => (
                <div key={item} className="flex items-center gap-2">
                  <span className="text-orange-500">✓</span>
                  <span>{item}</span>
                </div>
              ))}
            </div>
          </div>
          <div className="bg-gradient-to-r from-violet-50 to-pink-50 rounded-2xl p-6 border-2 border-violet-200 mb-6">
            <h3 className="text-xl font-bold heading-font text-violet-700 mb-3">Events We Specialize In</h3>
            <div className="flex flex-wrap justify-center gap-3">
              {EVENT_TYPES.map((event) => (
                <span key={event} className="bg-white px-4 py-2 rounded-full border-2 border-orange-200 font-semibold text-gray-700">{event}</span>
              ))}
            </div>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="bg-white rounded-2xl p-6 border-2 border-orange-200">
              <h3 className="text-xl font-bold heading-font text-orange-600 mb-3">Delivery & Pickup</h3>
              <p className="text-gray-700">By appointment only. Extra delivery cost based on location.</p>
            </div>
            <div className="bg-white rounded-2xl p-6 border-2 border-orange-200">
              <h3 className="text-xl font-bold heading-font text-orange-600 mb-3">Service Area</h3>
              <p className="text-gray-700">Havertown, Delaware County, Montgomery County & surrounding PA areas</p>
            </div>
          </div>
        </div>
      </motion.div>
    </div>
  </section>
);

export default HomeAbout;
